<app-page-panel
  [showBackButton]="true"
  iconNameFontAwesome="key"
  pageTitle="Berechtigungen | Authentifizierung"
  [showDetailsButton]="false"
  [showSidepanelButton]="false"
  [showBackColor]="true"
  (backButtonClicked)="backButtonClicked()">
    <div class="flex flex-fill flex-gap-8 flex-col flex-stretch-self">
        <p class="font-title-contrast">Ihre Identität konnte nicht ermittelt werden.</p>
        <p class="font-subtitle-contrast">Für den Zugriff auf das HCH-BAT (Budgetantragstool) benötigen Sie einen Microsoft-ID und die entsprechenden Berechtigungen zum Aufrufen der App.<br>
        Bitte erstellen Sie einen Account bei Microsoft und wenden Sie sich für die Einrichtung des Zugangs an die IT-Abteilung der HafenCity GmbH.<br>
        </p>
        <p class="font-title-contrast">Kontakt und AnsprechpartnerInnen</p>
        <p class="font-subtitle-contrast">
            HafenCity Hamburg GmbH<br>
            Osakaallee 11<br>
            20457 Hamburg<br>
            Telefon: (040) 374726 0<br>
            <a href="https://www.hafencity.com/kontakt" target="_blank">www.hafencity.com/kontakt</a><br>
        </p>   
        <p class="font-subtitle-contrast">
            Jeannine Thiel<br>
            <a href="mailto:thiel@hafencity.com">thiel&#64;hafencity.com</a><br>
            Finanzen und Controlling<br>
            HafenCity Hamburg GmbH<br>
            Osakaallee 11, D 20457 Hamburg<br>
            Tel: +49 40 374726 - 66<br>
        </p>
        <br>   
        <p class="font-subtitle-contrast">
        Mit freundlichen Grüßen<br>
        Ihre HafenCity GmbH
        </p>
    </div>
</app-page-panel>